const ObjParameterValueStorage = {
  racks: {
    select_calculations: -1
  },
  key(key) {
    return `ObjParameterValueStorage_${key}`;
  },
  get(key) {
    const lsKey = ObjParameterValueStorage.key(key);
    if (localStorage && localStorage.getItem(lsKey)) {
      return localStorage.getItem(lsKey);
    }

    if (ObjParameterValueStorage.racks.hasOwnProperty(key)) {
      return ObjParameterValueStorage.racks[key]
    }
    return null;
  },
  set(key, val) {
    const lsKey = ObjParameterValueStorage.key(key);
    if (localStorage) {
      localStorage.setItem(lsKey, val)
    }
    ObjParameterValueStorage.racks[key] = val;
    return true;
  }
};

export default ObjParameterValueStorage;
